var tabsName = [
				'Multiple <br> MIDs <br> support',
				'Gateway  <br> Services',
				'Merchant <br> Portal',
				'Fraud &amp; Risk <br> Management'
				];

var swiperHowItWorks = new Swiper ('.js-swiper-container', {
	direction: 'horizontal',
	loop: true,
	simulateTouch: false,
	pagination: {
		el: '.js-swiper-pagination',
		clickable: true,
		renderBullet: function (index, className) {
			return '<span class="' + className + '">' + (tabsName[index]) + '</span>';
		},
	},
	breakpoints: {
		768: {
			slidesPerView: 1,
			spaceBetween: 30,
			simulateTouch: true,
		}
	},
});
